var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.2468 13.9703C29.2787 13.9703 30.9262 12.3239 30.9262 10.292C30.9262 8.26011 29.2786 6.61255 27.2468 6.61255C25.2154 6.61255 23.5679 8.26011 23.5679 10.292C23.5679 12.3239 25.2154 13.9703 27.2468 13.9703Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.958 17.5157C31.7941 16.5306 30.9798 15.1518 30.3634 14.5359C30.2822 14.4542 29.9193 14.4354 29.8213 14.4961C29.072 14.957 28.1917 15.2282 27.247 15.2282C26.3033 15.2282 25.423 14.957 24.6735 14.4961C24.5751 14.4354 24.2127 14.4542 24.1315 14.5359C23.9592 14.7082 23.7712 14.9376 23.5879 15.2036C24.0838 16.1373 24.4771 17.1292 24.6191 17.9833C24.761 18.8396 24.7149 19.6502 24.4855 20.3892C25.3003 20.684 26.2775 20.8134 27.2469 20.8134C29.7753 20.8134 32.3628 19.9367 31.958 17.5157Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.9055 12.4182C19.1984 12.4182 21.8681 9.74843 21.8681 6.45555C21.8681 3.16368 19.1984 0.493927 15.9055 0.493927C12.6131 0.493927 9.94434 3.16368 9.94434 6.45555C9.94434 9.74843 12.613 12.4182 15.9055 12.4182Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.9541 13.3314C20.8248 13.2026 20.2372 13.1697 20.0775 13.2686C18.862 14.0164 17.4355 14.4542 15.9053 14.4542C14.3761 14.4542 12.949 14.0164 11.7341 13.2686C11.5745 13.1696 10.9869 13.2026 10.8575 13.3314C9.8562 14.3317 8.53652 16.5678 8.27102 18.1619C7.61639 22.0886 11.8106 23.5062 15.9053 23.5062C20.001 23.5062 24.1952 22.0886 23.5406 18.1619C23.2751 16.5678 21.9554 14.3317 20.9541 13.3314Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.75317 13.9703C6.78454 13.9703 8.43204 12.3239 8.43204 10.292C8.43204 8.26011 6.78454 6.61255 4.75317 6.61255C2.72123 6.61255 1.07373 8.26011 1.07373 10.292C1.07373 12.3239 2.72123 13.9703 4.75317 13.9703Z",
    fill: "#F9AA2A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M7.1934 17.9833C7.34428 17.0862 7.76997 16.03 8.30365 15.0533C8.1549 14.8501 8.00622 14.6731 7.86897 14.5359C7.78778 14.4542 7.4254 14.4354 7.32697 14.4961C6.57753 14.957 5.69722 15.2282 4.75309 15.2282C3.80884 15.2282 2.92797 14.957 2.17915 14.4961C2.08115 14.4354 1.71778 14.4542 1.63659 14.5359C1.01865 15.1517 0.206467 16.5306 0.0419673 17.5157C-0.362283 19.9367 2.22472 20.8133 4.75309 20.8133C5.6554 20.8133 6.56659 20.7022 7.34428 20.4483C7.09922 19.6942 7.04734 18.8647 7.1934 17.9833Z",
    fill: "#F9AA2A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.cf9e18f630cc3d4cb807f3293ce90dbe.svg";
export { ForwardRef as ReactComponent };